"use strict";

define('evisions/drag',['evisions/drop', 'evisions/helper', 'jquery', 'jquery.hammer'], function (EVIDrop, EVIHelper, $, Hammer) {
  var nextId = function nextId() {
    return this._nextEventId ? this._nextEventId++ : this._nextEventId = 1;
  };
  var proxy = function proxy(fn, obj) {
    return function () {
      return fn.apply(obj, arguments);
    };
  };
  var functionate = function functionate(obj) {
    if (typeof obj !== 'function') {
      return function () {
        return obj;
      };
    }
    return obj;
  };
  var EVIDrag = function EVIDrag(el, selector, options) {
    var that = this;
    this._eventId = '.' + 'evidrag' + nextId();
    this.$el = $(el);
    this.el = this.$el.get(0);
    this.selector = selector;
    this.options = options || {};
    this._callbacks = {
      init: $.Callbacks(),
      start: $.Callbacks(),
      move: $.Callbacks(),
      end: $.Callbacks(),
      release: $.Callbacks()
    };
    this._cache = {};
    this._getters = {};
    if (EVIHelper.isIE() != 9) {
      this.options.stop_browser_behavior = {
        userSelect: true
      };
    }
    var hammerObj = this.$el.hammer(this.options).on('drag' + this._eventId, proxy(function () {
      this._dragging && this.handleDragMove.apply(this, arguments);
    }, this)).on('touch' + this._eventId, this.selector, proxy(this.handleDragInit, this)).on('dragstart' + this._eventId, proxy(this.handleDragStart, this)).on('dragend' + this._eventId, proxy(function () {
      this._dragging && this.handleDragEnd.apply(this, arguments);
    }, this)).on('release' + this._eventId, this.selector, proxy(this.handleDragRelease, this)).on('release' + this._eventId, proxy(function () {
      this._wasDragging && this.handleDragRelease.apply(this, arguments);
    }, this));
  };
  EVIDrag.prototype = {
    defaults: {
      container: function container() {
        return this.$el;
      },
      ghostPosition: function ghostPosition(el) {
        var container = this.get('container'),
          elemOff = el.offset(),
          offset = container.offset(),
          pos = {
            top: elemOff.top - offset.top,
            left: elemOff.left - offset.left
          };
        return pos;
      },
      isDraggedElement: function isDraggedElement(el, dragged) {
        return el === dragged;
      },
      bounds: function bounds() {
        var ghost = this.get('ghost'),
          placeholder = this.get('placeholder'),
          sortableElement = this.get('sortableElement'),
          draggable = this.get('sortableElements').not(ghost).not(placeholder ? sortableElement : null),
          i = 0,
          len = draggable.length,
          bounds = [],
          el = null,
          offset = null;
        if (!draggable.has(placeholder.get(0))) {
          draggable = draggable.add(placeholder);
        }
        for (i = 0; i < len; ++i) {
          el = draggable.eq(i);
          offset = el.offset();
          bounds.push({
            element: el.get(0),
            top: offset.top,
            left: offset.left,
            right: offset.left + el.outerWidth(),
            bottom: offset.top + el.outerHeight()
          });
        }
        return bounds;
      },
      sortableElements: function sortableElements(filter) {
        return this.$el.find(this.selector).not(filter);
      },
      dragElement: function dragElement(el) {
        return el;
      }
    },
    init: function init(fn) {
      this._callbacks.init.add(fn);
      return this;
    },
    start: function start(fn) {
      this._callbacks.start.add(fn);
      return this;
    },
    move: function move(fn) {
      this._callbacks.move.add(fn);
      return this;
    },
    end: function end(fn) {
      this._callbacks.end.add(fn);
      return this;
    },
    release: function release(fn) {
      this._callbacks.release.add(fn);
      return this;
    },
    trigger: function trigger(name) {
      var args = [].concat.apply([], arguments).slice(1);
      if (this._callbacks[name]) {
        this._callbacks[name].fire.apply(this, args);
      }
      return this;
    },
    delegateDrop: function delegateDrop(selector) {
      var drop = new EVIDrop(this, selector),
        dd = this.dropDelegates = this.dropDelegates || [];
      dd.push(drop);
      return drop;
    },
    setCurrentlyDragged: function setCurrentlyDragged(el) {
      if (el) {
        this.currentlyDragged = $(el);
      } else {
        this.currentlyDragged = null;
      }
      return this;
    },
    getCurrentlyDragged: function getCurrentlyDragged() {
      return this.currentlyDragged;
    },
    handleDragMove: function handleDragMove(ev) {
      if (this._dragging && this._dragStarted && this._draggingObject == this) {
        this._lastDragMoveArgs = arguments;
        this._callbacks.move.fire.apply(this, arguments);
      }
    },
    handleDragInit: function handleDragInit(ev) {
      this._dragging = true;
      this._draggingObject = this;
      this.setCurrentlyDragged(ev.currentTarget);
      this._callbacks.init.fire.apply(this, arguments);
    },
    handleDragRelease: function handleDragRelease(ev) {
      this._wasDragging = false;
      this._callbacks.release.fire.apply(this, arguments);
    },
    handleDragStart: function handleDragStart(ev) {
      if (this._draggingObject != this || !this._dragging) {
        return;
      }
      this._dragStarted = true;
      $('body').addClass('unselectable');
      if (ev.gesture) {
        ev.gesture.preventDefault();
      } else if (ev.originalEvent) {
        ev.originalEvent.preventDefault();
      }
      this._callbacks.start.fire.apply(this, arguments);
    },
    handleDragEnd: function handleDragEnd(ev) {
      if (this._draggingObject != this || !this._dragging) {
        return;
      }
      $('body').removeClass('unselectable');
      if (this._dragStarted) {
        this._callbacks.end.fire.apply(this, arguments);
      }
      this._dragging = false;
      this._wasDragging = true;
      this._dragStarted = false;
      this.setCurrentlyDragged(null);
      this._cache = {};
    },
    plugin: function plugin(_plugin) {
      _plugin = _plugin || {};
      var init = _plugin.init,
        start = _plugin.start,
        move = _plugin.move,
        end = _plugin.end,
        release = _plugin.release,
        callbacks = _plugin.callbacks;
      if (init) {
        this.init(init);
      }
      if (start) {
        this.start(start);
      }
      if (move) {
        this.move(move);
      }
      if (end) {
        this.end(end);
      }
      if (release) {
        this.release(release);
      }
      if (callbacks) {
        var i = 0,
          that = this,
          len = callbacks.length || 0;
        for (i = 0; i < len; ++i) {
          this.addCallback(callbacks[i]);
        }
      }
      return this;
    },
    addCallback: function addCallback(name) {
      var that = this;
      if (this._callbacks[name] == null && this[name] == null) {
        this._callbacks[name] = $.Callbacks();
        that[name] = function (fn) {
          that._callbacks[name].add(fn);
          return that;
        };
      }
    },
    get: function get(name) {
      var cache = this._cache || (this._cache = {}),
        args = [].concat.apply([], arguments).slice(1),
        getter = null,
        value = cache[name];
      if (!value) {
        getter = this._getters[name] || this.defaults[name];
        if (getter) {
          value = cache[name] = getter.apply(this, args);
        }
      }
      return value;
    },
    clear: function clear(name) {
      var cache = this._cache || (this._cache = {});
      cache[name] = null;
      return this;
    },
    set: function set(name, fn) {
      this._getters[name] = functionate(fn);
      return this;
    },
    has: function has(name) {
      return !!this._getters[name];
    },
    isCached: function isCached(name) {
      var cache = this._cache || (this._cache = {});
      return !!cache[name];
    },
    destroy: function destroy() {
      this._destroyed = true;
      this.$el.off(this._eventId);
    }
  };
  EVIDrag.delegate = function (el, selector, options) {
    return new this(el, selector, options);
  };
  var ScrollerPlugin = {
    startScroll: function startScroll(speed, el, dropDelegates) {
      var realEl = el.get(0);
      realEl._scrollSpeed = speed;
      realEl._scrollInterval = setInterval(function () {
        el.scrollTop(el.scrollTop() + realEl._scrollSpeed);
        for (var i = 0, len = dropDelegates ? dropDelegates.length : 0; i < len; i++) {
          dropDelegates[i].dropzonesMoved();
        }
      }, 1);
    },
    isScrolling: function isScrolling(el) {
      return !!el.get(0)._scrollInterval;
    },
    setSpeed: function setSpeed(speed, el) {
      el.get(0)._scrollSpeed = speed;
    },
    killScroll: function killScroll(el) {
      var realEl = el.get(0);
      el.get(0)._scrollSpeed = 0;
      clearInterval(realEl._scrollInterval);
      realEl._scrollInterval = undefined;
    }
  };
  EVIDrag.plugins = {};
  EVIDrag.plugins.scroller = {
    init: function init(ev) {},
    move: function move(ev) {
      if (this.has('scrollContainer')) {
        var sc = this.get('scrollContainer'),
          offset = sc.offset(),
          top = offset.top,
          left = offset.left,
          bottom = top + sc.outerHeight(),
          right = left + sc.outerWidth(),
          cursorX = ev.gesture.center.pageX,
          cursorY = ev.gesture.center.pageY,
          speed = 0;
        if (cursorX > left && cursorX < right && cursorY > top && cursorY < bottom) {
          if (cursorY < top + 100) {
            speed = -(100 + (top - cursorY));
          }
          if (cursorY > bottom - 100) {
            speed = 100 - (bottom - cursorY);
          }
          speed /= 5;
          if (speed) {
            if (ScrollerPlugin.isScrolling(sc)) {
              ScrollerPlugin.setSpeed(speed, sc);
            } else {
              ScrollerPlugin.startScroll(speed, sc, this.dropDelegates);
            }
          } else {
            ScrollerPlugin.killScroll(sc);
          }
        }
      }
    },
    end: function end(ev) {
      ScrollerPlugin.killScroll(this.get('scrollContainer'));
    }
  };
  EVIDrag.plugins.ghost = {
    init: function init(ev) {
      this._originalElement = $(ev.currentTarget);
    },
    start: function start(ev) {
      if (this.has('ghost')) {
        var container = this.get('container'),
          elemOff = this._originalElement.offset(),
          offset = container.offset(),
          that = this,
          pos = {
            top: elemOff.top - offset.top,
            left: elemOff.left - offset.left
          };
        this.get('ghostPosition', this._originalElement);
        this.get('ghost', this._originalElement).css({
          zIndex: '2000',
          position: 'absolute'
        });
        this.get('ghost').on('mousewheel', function (ev) {
          that.trigger('scroll', ev);
        });
        container.append(this.get('ghost'));
      }
    },
    move: function move(ev) {
      if (this.has('ghost')) {
        var pos = this.get('ghostPosition', this._originalElement);
        this.get('ghost').css({
          top: pos.top + ev.gesture.deltaY,
          left: pos.left + ev.gesture.deltaX
        });
      }
    },
    end: function end(ev) {
      var ghost = this.get('ghost');
      if (ghost) {
        ghost.remove();
      }
    },
    callbacks: ['scroll']
  };
  var SortablePlugin = {
    boundsCheck: function boundsCheck(pos, bound) {
      var that = this;
      if (pos.x >= bound.left && pos.x < bound.right && pos.y >= bound.top && pos.y < bound.bottom) {
        if (!bound._entered) {
          bound._entered = true;
          return true;
        }
      } else {
        if (bound._entered) {
          bound._entered = false;
        }
      }
    },
    processBounds: function processBounds(bounds, draggedElement) {
      var i = 0,
        len = bounds ? bounds.length || 0 : 0;
      for (i = 0; i < len; ++i) {
        if (this.get('isDraggedElement', bounds[i].element, draggedElement)) {
          bounds[i]._draggedElement = true;
          if (this._startIndex == null) {
            this._startIndex = i;
          }
          this._currentIndex = i;
        }
        bounds[i]._dropSpace = i;
        this.clear('isDraggedElement');
      }
    }
  };
  EVIDrag.plugins.sortable = {
    init: function init(ev, drag) {
      EVIDrag.plugins.ghost.init.apply(this, arguments);
      this.get('sortableElement', $(ev.currentTarget));
    },
    start: function start(ev, dd) {
      EVIDrag.plugins.ghost.start.apply(this, arguments);
      var placeholder = null,
        el = this.get('sortableElement');
      if (this.has('placeholder')) {
        placeholder = this.get('placeholder', el);
        el.hide().before(placeholder);
      }
      var sortableItemInList = placeholder ? $(placeholder).get(0) : el.get(0);
      SortablePlugin.processBounds.call(this, this.get('bounds'), sortableItemInList);
    },
    move: function move(ev, dd) {
      EVIDrag.plugins.ghost.move.apply(this, arguments);
      var bounds = this.get('bounds'),
        cursorPos = {
          x: ev.gesture.center.pageX,
          y: ev.gesture.center.pageY
        },
        i = 0,
        enteredIndex = null,
        elementIndex = null,
        len = bounds.length,
        dragged = null,
        entered = null;
      for (i = 0; i < len; ++i) {
        if (bounds[i]._draggedElement !== true && SortablePlugin.boundsCheck.call(this, cursorPos, bounds[i])) {
          entered = bounds[i];
        } else if (bounds[i]._draggedElement === true) {
          dragged = bounds[i];
        }
      }
      if (entered && dragged) {
        var insertIndex = entered._dropSpace,
          el = $(dragged.element).detach(),
          placeholder = this.get('placeholder'),
          enteredElement = $(entered.element),
          action = 'before';
        if (insertIndex > dragged._dropSpace) {
          action = 'after';
        }
        enteredElement[action](el);
        this.clear('bounds');
        this.clear('sortableElements');
        SortablePlugin.processBounds.call(this, this.get('bounds'), el.get(0));
        this._didSwap = true;
      }
    },
    end: function end() {
      EVIDrag.plugins.ghost.end.apply(this, arguments);
      var placeholder = this.get('placeholder'),
        bounds = this.get('bounds');
      if (placeholder) {
        placeholder = $(placeholder);
        this.get('sortableElement').insertAfter(placeholder).show();
        placeholder.remove();
      }
      if (this._didSwap === true) {
        this.trigger('swap', this.getCurrentlyDragged(), this._startIndex, this._currentIndex);
      }
      this._startIndex = null;
      this._currentIndex = null;
      this._didSwap = null;
    },
    callbacks: ['swap']
  };
  return EVIDrag;
});

